module.exports = __webpack_public_path__ + "img/SaveTime.3666e142.svg";